import PropTypes from 'prop-types'
import { compose, pure, setDisplayName } from 'recompose'

import { withInputMask } from 'hoc/withInputMask'
import { FormSSNView } from 'components/form/ssn/FormSSNView'

export const FormSSN = compose(setDisplayName('FormSSN'), pure, withInputMask())(FormSSNView)

FormSSN.propTypes = {
  className: PropTypes.string,
  field: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func,
  handleShow: PropTypes.func,
  isDisabled: PropTypes.bool,
  isHidden: PropTypes.bool,
  isReadonly: PropTypes.bool,
  isRequired: PropTypes.bool,
  onChange: PropTypes.func,
  isOwnSSN: PropTypes.bool,
  title: PropTypes.node,
}
